<template>
  <b-modal size="lg" :visible="visible" centered no-close-on-backdrop no-close-on-esc>
    <div slot="modal-header" class="w-100">
      <h5>Confirm Delete
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <div>
      <div class="alert alert-danger col" role="alert" v-show="generalErrorMessage">
        <div>{{ generalErrorMessage }}</div>
      </div>
      <slot>
        <font-awesome-icon size="sm" class="text-warning mr-2 align-baseline" icon="exclamation-triangle"/> Are you sure you want to delete?
      </slot>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="deleteEstimate(estimate)">Ok</button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>
</template>

<script>
  import api from '@/services/api'
  import ErrorsMixin from '../mixins/ErrorsMixin'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'delete-estimate-modal',

    props: {
      visible: {
        type: Boolean,
        required: true
      },
      estimate: {}
    },

    mixins: [ErrorsMixin, AnalyticsMixin],

    data () {
      return {
      }
    },

    methods: {

      closeModal () {
        this.$emit('update:visible', false)
      },

      deleteEstimate (estimate) {
        this.clearAllErrors()
        api.delete('/Dashboard/Estimate/' + estimate.organizationPatientEstimateId).then(response => {
          this.$emit('estimateDeleted')
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.trackEvent(this.$options.name, 'DeleteError', error)
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
